import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import FarmersPage from './pages/FarmersPage';
import FarmerDetailPage from './pages/FarmerDetailPage';
import PostsPage from './pages/PostsPage';
import PostDetailPage from './pages/PostDetailPage';
import TermsPage from './pages/TermsPage';
import SofixInfoPage from './pages/SofixInfoPage';
import PesticidesInfoPage from './pages/PesticidesInfoPage';
import VisibilityPage from './pages/VisibilityPage';
import DoctorsPage from './pages/DoctorsPage';
import DoctorDetailPage from './pages/DoctorDetailPage';
import TimeTreePage from './pages/TimeTreePage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import AdminMenuPage from './pages/AdminMenuPage';
import AdminReviewPage from './pages/AdminReviewPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import AdminHeaderTickerPage from './pages/AdminHeaderTickerPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminSiteAdminsPage from './pages/AdminSiteAdminsPage';
import MePage from './pages/MePage';
import MeReportStatusPage from './pages/MeReportStatusPage';
import SettingsPage from './pages/SettingsPage';
import DebugHeaderTickerPage from './pages/DebugHeaderTickerPage';
import ProtectedRoute from './components/ProtectedRoute';
import NotFoundPage from './pages/NotFoundPage';
import ScrollToTop from './components/ScrollToTop';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/farmers" element={<FarmersPage />} />
        <Route path="/farmers/:slug" element={<FarmerDetailPage />} />
        <Route path="/doctors" element={<DoctorsPage />} />
        <Route path="/visibility" element={<VisibilityPage />} />
        <Route path="/doctors/:doctorKey" element={<DoctorDetailPage />} />
        <Route path="/timetree" element={<TimeTreePage />} />
        <Route path="/posts" element={<PostsPage />} />
        <Route path="/posts/:slug" element={<PostDetailPage />} />
        <Route path="/debug/header-ticker" element={<DebugHeaderTickerPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/sofix" element={<SofixInfoPage />} />
        <Route path="/pesticides" element={<PesticidesInfoPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdminConsole>
              <AdminMenuPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/header-ticker"
          element={
            <ProtectedRoute requireOperator>
              <AdminHeaderTickerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute requireOperator>
              <AdminUsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/site-admins"
          element={
            <ProtectedRoute requireSiteAdmin>
              <AdminSiteAdminsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/review"
          element={
            <ProtectedRoute requireReviewAccess>
              <AdminReviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reports"
          element={
            <ProtectedRoute requireReportsAccess>
              <AdminPage mode="posts" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/farmers"
          element={
            <ProtectedRoute requireOperator>
              <AdminPage mode="farmers" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/doctors"
          element={
            <ProtectedRoute requireOperator>
              <AdminPage mode="doctors" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/accounts"
          element={
            <ProtectedRoute requireOperator>
              <AdminSettingsPage mode="accounts" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute requireOperator>
              <AdminSettingsPage mode="settings" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/me"
          element={
            <ProtectedRoute>
              <MePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/me/reports-status"
          element={
            <ProtectedRoute>
              <MeReportStatusPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}
